// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._494JRh4yx{margin-right:4px;vertical-align:middle}._5WIWVR5Nx{}._622Is2ezx{}._7BbW4TrGx{}._2APgkzNSx{}._2APgkzNSx>*{vertical-align:middle}._52ctFGV6x{margin:-8px}._64kSoeJKx{margin:0;padding:0;text-indent:0;list-style-type:none}._22liVHeAx{}._50LEprmSx{display:inline-block;max-width:200px;height:24px;line-height:24px;padding:0 8px;color:var(--secondary-text);border-radius:2px;text-decoration:none}._7x1hgG7Wx{}._2vrRA6Z3x{}._2vrRA6Z3x:hover{background-color:var(--ui-subtle-hover);color:var(--secondary-text)}@media screen and (-ms-high-contrast: active){._2vrRA6Z3x:hover{background-color:highlight}}._2vrRA6Z3x:active{background-color:var(--ui-subtle-active);color:var(--secondary-text)}._1W2KFtpax{color:var(--secondary-text);width:16px;height:24px;line-height:24px;text-align:center}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"padded-icon": "_494JRh4yx",
	"paddedIcon": "_494JRh4yx",
	"gravatar": "_5WIWVR5Nx _494JRh4yx",
	"link": "_622Is2ezx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unanchor"] + "",
	"org-icon": "_7BbW4TrGx _494JRh4yx",
	"orgIcon": "_7BbW4TrGx _494JRh4yx",
	"app-icon": "_2APgkzNSx _494JRh4yx",
	"appIcon": "_2APgkzNSx _494JRh4yx",
	"container": "_52ctFGV6x",
	"list": "_64kSoeJKx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["paragraph-m"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"list-item": "_22liVHeAx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"listItem": "_22liVHeAx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"crumb": "_50LEprmSx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-flush"] + "",
	"crumb-text": "_7x1hgG7Wx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"crumbText": "_7x1hgG7Wx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"crumb-link": "_2vrRA6Z3x _50LEprmSx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-flush"] + "",
	"crumbLink": "_2vrRA6Z3x _50LEprmSx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-flush"] + "",
	"separator": "_1W2KFtpax"
};
module.exports = exports;
